import { StyleSheet, View, Text, Image, StyleProp, ImageStyle } from 'react-native';
import React from 'react';
import { wreathLeft, wreathRight } from '../../asset/images';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { Fonts, GenericSize } from '../../module/types';
import { ScreenTypes } from '../../module/ThemeManager';
import { IContestAward, ITopUser, IUserSummary } from '../../types/global/helper';
import { Stack } from '@mui/material';

interface IWreathe {
    imageStyle?: StyleProp<ImageStyle>;
    withImage?: boolean;
    contestAward?: IContestAward;
    onWreatheClick?: (user?: IUserSummary | ITopUser | undefined) => void;
    customComponent?: React.ReactNode;
    textLine1: string;
    textLine2: string;
    textLine3: string;
}

const SplitWreathe = ({ imageStyle, textLine1, textLine2, textLine3 }: IWreathe) => {
    const { device, themeStyle, sizes } = useThemeContext();
    const styles = dynamicStyles(themeStyle, sizes.genericSize, sizes.font, device);
    return (
        <Stack style={styles.container}>
            <View style={styles.leftWreath}>
                <Image source={wreathLeft} style={[styles.image, imageStyle]} />
            </View>
            <View style={styles.centerContent}>
                <Text style={styles.textLine1}>{textLine1}</Text>
                <Text style={styles.textLine2}>{textLine2}</Text>
                <Text style={styles.textLine3}>{textLine3}</Text>
            </View>
            <View style={styles.rightWreath}>
                <Image source={wreathRight} style={[styles.image, imageStyle]} />
            </View>
        </Stack>
    );
};
export { SplitWreathe };

const dynamicStyles = (colorScheme: ColorScheme, size: GenericSize, font: Fonts, device: ScreenTypes) =>
    StyleSheet.create({
        container: {
            flexDirection: 'row',
            alignItems: 'stretch', // Ensure items stretch vertically
            justifyContent: 'center',
            minHeight: 10,
        },
        leftWreath: {
            flex: 1, // Make the left wreath expand to take available vertical space
        },
        centerContent: {
            flex: 1, // Make the center content expand to take available vertical space
            justifyContent: 'center', // Center content vertically
            alignItems: 'center', // Center content horizontally
            width: 'auto',
        },
        rightWreath: {
            flex: 1, // Make the right wreath expand to take available vertical space
        },
        image: {
            height: '100%', // Image takes the full height of its container
            width: '100%', // Image takes the full width of its container
            tintColor: theme[colorScheme].true_white,
            resizeMode: 'contain',
        },
        textLine1: {
            color: theme[colorScheme].true_white,
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            fontSize: 6,
            textTransform: 'uppercase',
            textAlign: 'center',
        },
        textLine2: {
            color: theme[colorScheme].true_white,
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            fontSize: 8,
            textTransform: 'uppercase',
            textAlign: 'center',
            paddingHorizontal: 10,
        },
        textLine3: {
            color: theme[colorScheme].true_white,
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            fontSize: 4,
            textTransform: 'uppercase',
            textAlign: 'center',
        },
    });
